import readXlsxFile from 'read-excel-file'
import { getColumnsExcel, formatColumnExcel } from '../../stock/services/config';
import { getStockData } from '../../common/store/reducers/stock';
import { addStock2, updateStockImport } from '../../actions';
import { pad } from '../../common/services/util'

const executeImportExcel = (file, props, state, setState) => {
    readXlsxFile(file).then(rows => {
        let stocks = rows.slice(1).map(row => {
            let stock = {}
            row.forEach( (value, index) => {
                let field = getColumnsExcel[index]
                let format = formatColumnExcel(index)

                stock[field] = format(value)
            })

            return stock
        })

        props.flagLoading(true)
        let stockAdd = stocks.filter(stock => !stock.reference)
        let stockUpdated = stocks.filter(stock => stock.reference)

        Promise.all([arrayAddStock(stockAdd), arrayUpdatedStock(props, stockUpdated)]).then(values => {
            const stockCorrect = values[1][0]
            const stockError = values[1][1]

            const newState = { 
                ...state, 
                importData: { 
                    openModal: true, 
                    dataAdded: stockAdd, 
                    dataUpdated: stockCorrect,
                    dataError: stockError
                } 
            }
            setState(newState)
            props.flagLoading(false)
        })
    })
}

const arrayUpdatedStock = async (props, arrayStock) => {
    let stockData = getStockData(props.stock)
    let stockError = []
    let stockCorrect = []

    for (let stock of arrayStock) {
        let refString = pad(stock.reference, 4)
        const stockFilter = stockData.filter(s => s.reference === refString)

        if (stockFilter.length === 0) {
            stockError.push({ reference: refString, error: 'Referencia incorrecta'})
            continue
        }

        let id = stockData.filter(s => s.reference === refString)[0].id
        await updateStockImport({...stock, id})
        stockCorrect.push(stock)
    }

    return [stockCorrect, stockError]
}

const arrayAddStock = async (arrayStock) => {
    for (let stock of arrayStock) {
        await addStock2(stock)
    }
}

export default executeImportExcel